import React, { useState } from "react";
import Box from "@mui/material/Box";
import { useReferentialContext } from "../../Context";
import { MultipleSelectorGrouped } from "../Abstract/Multiple";
import { SingleSelectorGrouped } from "../Abstract/Single";
import {Maps} from "../../reckon-api";
import {capitalize} from "@mui/material";
import {ValorantApi} from "../../valorant-api/api";

export function SingleMapSelect(props: { value: Maps | null; updateValue: (newValue: Maps | null) => void }) {
    const { mapsReferential } = useReferentialContext();

    const updateSelection = (newSelection: Maps | null) => {
        props.updateValue(newSelection);
    };

    return (
        <Box sx={{ width: "150px" }}>
            <SingleSelectorGrouped
                getGroup={(option: Maps) => (option.id ? "Active" : "Inactif")}
                getOptionLabel={(option: Maps) => capitalize(option.id)}
                getOptionShort={(option: Maps) => capitalize(option.id)}
                options={mapsReferential}
                selected={props.value}
                updateSelection={updateSelection}
                optionDisabled={(option) => false}
                label={"Map"}
                // optionDecoration={(option) => (option.uuid ? <img src={`https://media.valorant-api.com/maps/${option.uuid}/listviewicon.png`} height="40" style={{ cursor: "pointer", marginRight: "10px" }} /> : <></>)}
                // inputDecoration={(option) => (option.logo ? <img src={option.logo} width="40" height="40" style={{ cursor: "pointer", marginRight: "10px" }} /> : <></>)}
            />
        </Box>
    );
}

